import React from 'react';

/* ===========================
RENDER
=========================== */
export function IconPlus() {
  return (
    <svg width="20px" height="20px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs>
        <path d="M22,25 C8.745166,25 -2,14.254834 -2,1 C-2,-12.254834 8.745166,-23 22,-23 C35.254834,-23 46,-12.254834 46,1 C46,14.254834 35.254834,25 22,25 Z M31.9651282,3.51064661 C33.0904029,3.51064661 34,2.4030084 34,1.27896073 C34,0.154913069 33.0904029,-0.953897246 31.9651282,-0.953897246 L24.5113553,-0.953897246 L24.5113553,-8.96757179 C24.5113553,-10.0904474 23.4024908,-11 22.2783883,-11 C21.1554579,-11 20.0465934,-10.0904474 20.0465934,-8.96757179 L20.0465934,-0.953897246 L12.0336996,-0.953897246 C10.9095971,-0.953897246 10,0.154913069 10,1.27896073 C10,2.4030084 10.9095971,3.51064661 12.0336996,3.51064661 L20.0465934,3.51064661 L20.0465934,10.9640555 C20.0465934,12.0881031 21.1554579,13 22.2783883,13 C23.4024908,13 24.5113553,12.0881031 24.5113553,10.9640555 L24.5113553,3.51064661 L31.9651282,3.51064661 Z" id="path-1" />
      </defs>
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="tool/add_circle" transform="translate(2.000000, 23.000000)">
          <mask id="mask-2" fill="white">
            <use xlinkHref="#path-1" />
          </mask>
          <use id="add_circle" fill="#FFFFFF" xlinkHref="#path-1" />
        </g>
      </g>
    </svg>
  );
}

export function IconSmile() {
  return (
    <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs>
        <path d="M16.7272727,12.3636364 C16.7272727,14.773998 14.7735605,16.7272727 12.3636364,16.7272727 C9.95371228,16.7272727 8,14.773998 8,12.3636364 C8,9.95327475 9.95371228,8 12.3636364,8 C14.7735605,8 16.7272727,9.95327475 16.7272727,12.3636364 Z M35.6363636,16.7272727 C33.2264395,16.7272727 31.2727273,14.773998 31.2727273,12.3636364 C31.2727273,9.95327475 33.2264395,8 35.6363636,8 C38.0462877,8 40,9.95327475 40,12.3636364 C40,14.773998 38.0462877,16.7272727 35.6363636,16.7272727 Z M13.3327729,25.4545455 C13.3327729,30.8099656 18.109068,35.1510097 24,35.1510097 C29.890932,35.1510097 34.6655459,30.8099656 34.6655459,25.4545455 L40,25.4545455 C40,33.4876757 32.836398,40 24,40 C15.163602,40 8,33.4876757 8,25.4545455 L13.3327729,25.4545455 Z" id="path-1" />
      </defs>
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="EXPRESSION-/-Smile" transform="translate(-8.000000, -8.000000)">
          <mask id="mask-2" fill="white">
            <use xlinkHref="#path-1" />
          </mask>
          <use id="smile" fill="#000000" xlinkHref="#path-1" />
        </g>
      </g>
    </svg>
  );
}

function IconVideriLogo() {
  return (
    <svg width="40" height="40" viewBox="0 0 54 78" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M21.5336 45.4852C23.3404 48.609 27.3349 49.6865 30.4586 47.8797C33.5824 46.0838 34.6599 42.0893 32.864 38.9547L12.6956 4.02731C10.8888 0.903546 6.89434 -0.173989 3.77058 1.63279C0.646817 3.43956 -0.430718 7.43406 1.37606 10.5578L21.5336 45.4852ZM53.5005 7.29256C53.5005 10.8993 50.5767 13.8231 46.97 13.8231C43.3633 13.8231 40.4395 10.8993 40.4395 7.29256C40.4395 3.68586 43.3633 0.762053 46.97 0.762053C50.5767 0.762053 53.5005 3.68586 53.5005 7.29256Z" fill="#01070B" />
      <path d="M6.61553 76.9288H7.89653L12.0125 65.5888H10.7525L7.25603 75.2803L3.74903 65.5888H2.49953L6.61553 76.9288Z" fill="#01070B" />
      <path d="M13.906 63.2998H15.1135V61.7563H13.906V63.2998ZM13.906 76.9288H15.1135V65.5888H13.906V76.9288Z" fill="#01070B" />
      <path d="M22.4167 77.2438C23.2987 77.2438 24.0617 77.0443 24.7057 76.6453C25.3567 76.2393 25.8817 75.6933 26.2807 75.0073V76.9288H27.3832V61.8088H26.1757V67.3108C25.7697 66.6738 25.2412 66.1768 24.5902 65.8198C23.9392 65.4558 23.1762 65.2738 22.3012 65.2738C21.2722 65.2738 20.3937 65.5398 19.6657 66.0718C18.9447 66.5968 18.3917 67.3108 18.0067 68.2138C17.6217 69.1098 17.4292 70.1178 17.4292 71.2378C17.4292 72.3718 17.6217 73.3938 18.0067 74.3038C18.3917 75.2068 18.9552 75.9243 19.6972 76.4563C20.4462 76.9813 21.3527 77.2438 22.4167 77.2438ZM22.4902 76.0888C21.6572 76.0888 20.9607 75.8753 20.4007 75.4483C19.8407 75.0213 19.4207 74.4438 19.1407 73.7158C18.8607 72.9808 18.7207 72.1548 18.7207 71.2378C18.7207 70.3278 18.8572 69.5123 19.1302 68.7913C19.4032 68.0633 19.8197 67.4893 20.3797 67.0693C20.9397 66.6423 21.6502 66.4288 22.5112 66.4288C23.3442 66.4288 24.0407 66.6353 24.6007 67.0483C25.1607 67.4613 25.5807 68.0283 25.8607 68.7493C26.1407 69.4703 26.2807 70.2998 26.2807 71.2378C26.2807 72.1618 26.1407 72.9913 25.8607 73.7263C25.5807 74.4543 25.1607 75.0318 24.6007 75.4588C24.0407 75.8788 23.3372 76.0888 22.4902 76.0888Z" fill="#01070B" />
      <path d="M34.7854 77.2438C35.8914 77.2438 36.8749 76.9778 37.7359 76.4458C38.5969 75.9068 39.2549 75.1508 39.7099 74.1778L38.6179 73.6948C38.2329 74.4578 37.7114 75.0458 37.0534 75.4588C36.4024 75.8648 35.6394 76.0678 34.7644 76.0678C33.5464 76.0678 32.5909 75.6793 31.8979 74.9023C31.2049 74.1183 30.8339 73.0193 30.7849 71.6053H39.9514C39.9794 69.6173 39.5349 68.0668 38.6179 66.9538C37.7009 65.8338 36.4164 65.2738 34.7644 65.2738C33.6794 65.2738 32.7414 65.5188 31.9504 66.0088C31.1594 66.4918 30.5504 67.1813 30.1234 68.0773C29.6964 68.9733 29.4829 70.0408 29.4829 71.2798C29.4829 72.4978 29.6964 73.5548 30.1234 74.4508C30.5574 75.3398 31.1699 76.0293 31.9609 76.5193C32.7589 77.0023 33.7004 77.2438 34.7854 77.2438ZM34.7854 66.4183C35.9334 66.4183 36.8329 66.7683 37.4839 67.4683C38.1419 68.1683 38.5304 69.1833 38.6494 70.5133H30.8059C30.9179 69.2043 31.3134 68.1963 31.9924 67.4893C32.6784 66.7753 33.6094 66.4183 34.7854 66.4183Z" fill="#01070B" />
      <path d="M42.064 76.9288H43.282V71.3113C43.282 70.8493 43.303 70.3768 43.345 69.8938C43.394 69.4038 43.506 68.9383 43.681 68.4973C43.863 68.0493 44.1465 67.6573 44.5315 67.3213C44.9655 66.9503 45.4345 66.7333 45.9385 66.6703C46.4495 66.6073 46.929 66.6283 47.377 66.7333V65.5888C46.88 65.4488 46.299 65.4418 45.634 65.5678C44.976 65.6938 44.4195 65.9633 43.9645 66.3763C43.6635 66.6353 43.3975 66.9678 43.1665 67.3738V65.5888H42.064V76.9288Z" fill="#01070B" />
      <path d="M49.3648 63.2998H50.5723V61.7563H49.3648V63.2998ZM49.3648 76.9288H50.5723V65.5888H49.3648V76.9288Z" fill="#01070B" />
    </svg>
  );
}

export function IconArrowDown() {
  return (
    <svg width="12px" height="8px" viewBox="0 0 32 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Parts/icon/dropdown" transform="translate(-8.000000, -14.000000)" fill="#000000" fillRule="nonzero">
          <g id="arrowsBold" transform="translate(24.000000, 24.000000) rotate(90.000000) translate(-24.000000, -24.000000) translate(14.000000, 8.000000)">
            <polygon id="Shape" points="3.78378378 0 0 3.73333333 12.4324324 16 0 28.2666667 3.78378378 32 20 16" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function IconArrowUp() {
  return (
    <svg width="12px" height="8px" viewBox="0 0 32 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Parts/icon/dropdown" transform="translate(-8.000000, -14.000000)" fill="#000000" fillRule="nonzero">
          <g id="arrowsBold" transform="translate(24.000000, 24.000000) rotate(-90.000000) translate(-24.000000, -24.000000) translate(14.000000, 8.000000)">
            <polygon id="Shape" points="3.78378378 0 0 3.73333333 12.4324324 16 0 28.2666667 3.78378378 32 20 16" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function IconSearch() {
  return (
    <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="icon_search_gray" fill="#D9D9D6" fillRule="nonzero">
          <path d="M21.6655044,20.0385142 L16.2421281,14.5927746 C17.6365734,12.9923814 18.4005983,10.9787593 18.4005983,8.88249131 C18.4005983,3.98476284 14.2732641,0 9.20029913,0 C4.12733419,0 0,3.98476284 0,8.88249131 C0,13.7802198 4.12733419,17.7649826 9.20029913,17.7649826 C11.1047611,17.7649826 12.9196201,17.2104062 14.4712705,16.1576379 L19.9358482,21.6447003 C20.1642556,21.8737141 20.4714656,22 20.8006763,22 C21.1122864,22 21.407896,21.8853 21.6323033,21.6767546 C22.1091188,21.2337886 22.1243193,20.4992452 21.6655044,20.0385142 Z M9.20029913,2.31717165 C12.950021,2.31717165 16.0005202,5.26229681 16.0005202,8.88249131 C16.0005202,12.5026858 12.950021,15.447811 9.20029913,15.447811 C5.45057722,15.447811 2.40007803,12.5026858 2.40007803,8.88249131 C2.40007803,5.26229681 5.45057722,2.31717165 9.20029913,2.31717165 Z" id="Shape" />
        </g>
      </g>
    </svg>
  );
}

export function IconRadioUnchecked() {
  return (
    <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Parts/icon/checkbox-uncheck" stroke="#000000" strokeWidth="2">
          <rect id="Rectangle-Copy" x="1" y="1" width="16" height="16" />
        </g>
      </g>
    </svg>
  );
}

export function IconRadioPartialChecked() {
  return (
    <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Parts/icon/checkbox-uncheck">
          <g id="Group">
            <rect id="Rectangle-Copy" fill="#000000" x="0" y="0" width="18" height="18" />
            <polygon id="Rectangle" fill="#FFFFFF" points="4 8 14.08261 8 14.08261 10 4 10" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function IconRadioChecked() {
  return (
    <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-2">
          <g id="Group" fill="#000000">
            <rect id="Rectangle-Copy" x="0" y="0" width="18" height="18" />
          </g>
          <g id="arrowsBold" transform="translate(9.000000, 8.500000) rotate(90.000000) translate(-9.000000, -8.500000) translate(4.000000, 2.000000)" fill="#FFFFFF" fillRule="nonzero">
            <polygon id="Shape" points="1.69189189 0.5 0.5 1.68461538 7.11621622 8.34615385 4.1 11.3153846 5.29189189 12.5 9.5 8.34615385" />
          </g>
        </g>
      </g>
    </svg>
  );
}

/* ===========================
EXPORT
=========================== */
export default IconVideriLogo;
